import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'src/app/services/auth/auth.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';


@Component({
  selector: 'app-primary-nav',
  templateUrl: './primary-nav.component.html',
  standalone:false,
  styleUrls: ['./primary-nav.component.scss']
})
export class PrimaryNavComponent implements OnInit {

  constructor(public router: Router, private readonly share: shareOpeSevices, private readonly authService: AuthService, private location: Location) {

  }


  prenom!: string | undefined;
  nom!: string | undefined;
  items!: MenuItem[];
  userRole!: string[];
  adminElement: string = "Admin.";

  ngOnInit() {


    this.share.userProfilshared$.subscribe(data => {

      this.nom = data?.nom;
      this.prenom = data?.prenom;
      this.userRole = data?.role;

    })

    this.items = [
      {
        label: 'Admi.',
        icon: "",
        items: [{
          label: 'Entité',
          icon: 'pi pi-fw pi-plus',

        }, {
          label: 'Vendeur',
          icon: 'pi pi-fw pi-plus',
        }
        ]
      },
    ];
    this.router.events.subscribe((event: Event) => {

      if (event instanceof NavigationEnd) {

        // Envoyer les données de navigation à un service d'analytics
        if (event.urlAfterRedirects == "/page-entites") {
          this.adminElement = "Entités"
        }
        else if (event.urlAfterRedirects == "/page-vendeurs") {
          this.adminElement = "Vendeurs"
        }
        /*else if (event.urlAfterRedirects == "/page-contacts") {
          this.adminElement = "Contacts"
        }*/
        else {
          this.adminElement = "Admin."
        }
      }

      /**if (event instanceof NavigationError) {
        // Rediriger vers une page d'erreur
        this.router.navigate(['/error'], {
          queryParams: { message: event.error.message }
        });
      }**/
    });

  }

  hasRole(role: string): boolean {

    if (this.userRole && this.userRole.length > 0) {
      return this.userRole.includes(role);
    }
    return false;
  }

  logout() {
    window.localStorage.clear();
    this.authService.logout();
  }
  activeTabStyle(tab1: any, tab2: any, tab3: any): string {
    if (this.location.path().indexOf(tab1) > -1 || this.location.path().indexOf(tab2) > -1 || this.location.path().indexOf(tab3) > -1) {
      return "is-active";
    }
    return "";
  }
}

